<i18n
  src="@/locales/views/service_provider/warehouse/movements/show_warehouse.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('')"
      :params="{
        service_provider_id: this.service_provider_id,
      }"
    ></go-back-link>

    <bread-crumbs :labels="[module_name, warehouse.name]"></bread-crumbs>

    <template v-if="load_data">
      <tabs-container v-model="option_tabs" :with_routing="true" />

      <router-view
        :service_provider_id="service_provider_id"
        :warehouse_id="warehouse_id"
      >
      </router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/service_provider/requesters/warehouse/movements/show_warehouse.js";

export default {
  name: "SPWarehouseMovementsShowWarehouse",
  data() {
    return {
      warehouse: {},
      option_tabs: [],
      load_data: false,
    };
  },
  props: {
    service_provider_id: {
      required: true,
    },
    warehouse_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fillOptionTabs();
        this.fetchWarehouse();
        this.load_data = true;
      });
    });
  },
  methods: {
    fetchWarehouse: async function () {
      let response = await Requester.fetchWarehouse(
        this.service_provider_id,
        this.warehouse_id
      );
      this.warehouse = response.data;
    },

    fillOptionTabs: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.inventory_movements_title"),
          icon: "fa-solid fa-arrow-right-arrow-left",
          route: { name: this.routeName("show_warehouse_movements") },
        },
        {
          name: this.$t("labels.inventory_items_title"),
          icon: "fa-solid fa-boxes",
          route: { name: this.routeName("show_warehouse_items") },
        },
      ];
    },
  },
};
</script>
